import styles from './dashboard.module.scss';
import { DashboardProps } from '../../../interfaces/components';
import ProfileCard from "../../../components/ProfileCard";
import ListPublicationStatesContainer from '../../../containers/Profile/Dashboard/ListPublicationStates/ListPublicationStatesContainer';
import FiltersContainer from '../../../containers/Profile/Dashboard/Filters/FiltersContainer';
import SalesPeriodContainer from '../../../containers/Profile/Dashboard/SalesPeriod/SalesPeriodContainer';
import SalesAcumulatedContainer from '../../../containers/Profile/Dashboard/SalesAcumulated/SalesAcumulatedContainer';
import StatusContainer from '../../../containers/Profile/Dashboard/Status/StatusContainer';
import PublicationsAndSalesContainer from '../../../containers/Profile/Dashboard/PublicationsAndSales/PublicationsAndSalesContainer';

const Dashboard = ({
    user
}: DashboardProps) => {

    return (
        <ProfileCard className={styles.profileCardContainer}>
            <FiltersContainer />
            <SalesPeriodContainer className={`${styles.cardComponent} ${styles.card1}`} />
            <SalesAcumulatedContainer className={`${styles.cardComponent} ${styles.card2}`} />
            <PublicationsAndSalesContainer className={`${styles.cardComponent} ${styles.card3}`} />
            <StatusContainer className={`${styles.cardComponent} ${styles.card4}`} />
            <ListPublicationStatesContainer className={`${styles.cardComponent} ${styles.card5}`} />
        </ProfileCard>
    )
};
export default Dashboard;